import React from "react";
import { Paper, Typography, Divider, Grid, Box, Chip } from "@mui/material";

const ProfileDetailsSection = ({ profile }) => {
  if (!profile) return null;

  const formatDate = (date) => {
    if (!date) return "N/A";
    try {
      return new Date(date).toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    } catch {
      return "Invalid Date";
    }
  };

  return (
    <Paper
      elevation={4}
      sx={{
        p: 4,
        mb: 3,
        borderRadius: 3,
      }}
    >
      <Typography
        variant="h5"
        sx={{
          fontWeight: "bold",
          mb: 2,
          color: "primary.main",
        }}
      >
        Detailed Profile Information
      </Typography>
      <Divider sx={{ mb: 3 }} />

      <Grid container spacing={3}>
        {/* LEFT COLUMN */}
        <Grid item xs={12} md={6}>
          <Typography px={0} py={1} m={0}>
            <strong>Date of Birth:</strong> {formatDate(profile.meta?.dob)}
          </Typography>
          <Typography px={0} py={1} m={0}>
            <strong>Education:</strong> {profile.meta?.education || "N/A"}
          </Typography>
          <Typography px={0} py={1} m={0}>
            <strong>Work:</strong> {profile.meta?.work || "N/A"}
          </Typography>
          <Typography px={0} py={1} m={0}>
            <strong>Income:</strong> {profile.meta?.income || "N/A"}
          </Typography>
          <Typography px={0} py={1} m={0}>
            <strong>Height:</strong> {profile.meta?.height || "N/A"}
          </Typography>
          <Typography px={0} py={1} m={0}>
            <strong>Body Type:</strong> {profile.meta?.bodyType || "N/A"}
          </Typography>
          <Typography px={0} py={1} m={0}>
            <strong>Ethnicity:</strong> {profile.meta?.ethnic || "N/A"}
          </Typography>
          <Typography px={0} py={1} m={0}>
            <strong>Health Conditions:</strong>{" "}
            {profile.meta?.healthConditions || "N/A"}
          </Typography>
          <Typography px={0} py={1} m={0}>
            <strong>Country:</strong> {profile.meta?.country?.name || "N/A"}
          </Typography>
          <Typography px={0} py={1} m={0}>
            <strong>City:</strong> {profile.meta?.city || "N/A"}
          </Typography>
        </Grid>

        {/* RIGHT COLUMN */}
        <Grid item xs={12} md={6}>
          <Typography px={0} py={1} m={0}>
            <strong>Sect:</strong> {profile.meta?.sect || "N/A"}
          </Typography>
          <Typography px={0} py={1} m={0}>
            <strong>How Religious:</strong>{" "}
            {profile.meta?.howReligious || "N/A"}
          </Typography>
          <Typography px={0} py={1} m={0}>
            <strong>Prays:</strong> {profile.meta?.prays || "N/A"}
          </Typography>
          <Typography px={0} py={1} m={0}>
            <strong>Fasts:</strong> {profile.meta?.fasts || "N/A"}
          </Typography>
          <Typography px={0} py={1} m={0}>
            <strong>Eats Halal:</strong> {profile.meta?.eatsHalal || "N/A"}
          </Typography>
          <Typography px={0} py={1} m={0}>
            <strong>Exercise:</strong> {profile.meta?.exercises || "N/A"}
          </Typography>
          <Typography px={0} py={1} m={0}>
            <strong>Community Activities:</strong>{" "}
            {profile.meta?.communityActivities || "N/A"}
          </Typography>
          <Typography px={0} py={1} m={0}>
            <strong>Convert / Revert:</strong>{" "}
            {profile.meta?.convertOrRevert || "N/A"}
          </Typography>
          <Typography px={0} py={1} m={0}>
            <strong>Marital Status:</strong>{" "}
            {profile.meta?.maritalStatus || "N/A"}
          </Typography>
        </Grid>
      </Grid>

      {/* INTERESTS */}
      {profile.meta?.interests && (
        <Box sx={{ mt: 1 }}>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 600, mb: 1 }}
            px={0}
            py={1}
            m={0}
          >
            Interests:
          </Typography>
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
            {Array.isArray(profile.meta.interests)
              ? profile.meta.interests.map((item, i) => (
                  <Chip
                    key={i}
                    label={item.name || item}
                    color="primary"
                    variant="outlined"
                  />
                ))
              : profile.meta.interests
                  .split(",")
                  .map((interest, i) => (
                    <Chip
                      key={i}
                      label={interest.trim()}
                      color="primary"
                      variant="outlined"
                    />
                  ))}
          </Box>
        </Box>
      )}

      {profile.meta?.personality && (
        <Box>
          <Typography>
            <strong>Personality Traits:</strong>
          </Typography>
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
            {Array.isArray(profile.meta.personality)
              ? profile.meta.personality.map((item, i) => (
                  <Chip
                    key={i}
                    label={item.name || item}
                    color="primary"
                    variant="outlined"
                  />
                ))
              : profile.meta.personality
                  .split(",")
                  .map((personality, i) => (
                    <Chip
                      key={i}
                      label={personality.trim()}
                      color="primary"
                      variant="outlined"
                    />
                  ))}
          </Box>
        </Box>
      )}

      <Grid item xs={12} sm={6}>
        {profile.meta.leisureActivities && (
          <Box sx={{ mt: 2 }}>
            <Typography  px={0} py={1} m={0}>
              <strong>Leisure Activities:</strong>
            </Typography>
            <Typography
              sx={{
                whiteSpace: "pre-line",
                color: "text.primary",
              }}
               px={0} py={1} m={0}
            >
              {profile.meta.leisureActivities}
            </Typography>
          </Box>
        )}
      </Grid>
    </Paper>
  );
};

export default ProfileDetailsSection;
